import { registerBlockType } from '@wordpress/blocks';

// import { gtueIcon as icon } from '../common/gtue_icon';
import edit from './edit';
import save from './save';
import metadata from './block.json';

const { name } = metadata;
export { metadata, name };


export default registerBlockType( 'gtue-newsroom/social-media-share', {
    title: 'Social Media Shares',
    keywords: ['GTÜ'],
    icon: {
    	background: '',
    	foreground: '',
    	src: <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"> <title>gtue-icon_s</title> <rect width="24" height="24" fill="none"/> <polygon points="20.9 7.62 24 7.62 24 8.62 20.9 8.62 20.9 7.62 20.9 7.62 20.9 7.62 20.9 7.62" fill="#d4072d" fill-rule="evenodd"/> <polygon points="16.87 7.62 20.43 7.62 20.43 8.62 16.87 8.62 16.87 7.62 16.87 7.62 16.87 7.62 16.87 7.62" fill="#d4072d" fill-rule="evenodd"/> <polygon points="9.56 9.34 16.16 9.34 16.16 12.44 14.59 12.44 14.59 16.47 11.13 16.47 11.13 12.44 9.56 12.44 9.56 9.34 9.56 9.34 9.56 9.34" fill="#d4072d" fill-rule="evenodd"/> <path d="M20.43,16.46h0a3.56,3.56,0,0,1-3.56-3.56h0V9.34h3.57v5.47h0a.23.23,0,1,0,.46,0h0V9.34H24v7.13H20.43Z" fill="#d4072d" fill-rule="evenodd"/> <path d="M1.71,12.9A3.57,3.57,0,0,1,5.28,9.34H8.84v3.1H5.28v2.37h0a.23.23,0,0,0,.46,0h0V12.9h3.1v3.57H5.28A3.57,3.57,0,0,1,1.71,12.9Z" fill="#d4072d" fill-rule="evenodd"/> <path d="M5.28,17.18H24v1H5.28a5.28,5.28,0,1,1,0-10.56H16.15v1H5.28a4.28,4.28,0,0,0,0,8.56Z" fill="#c5c5c6" fill-rule="evenodd"/> </svg>, },
    category: 'gtue-elements',
    "attributes": {
    	fb_url: {"type": "string", "source": "attribute", "default": "", "selector": "a.fb_a_link", "attribute": "href" },
    	tw_url: {"type": "string", "source": "attribute", "default": "", "selector": "a.tw_a_link", "attribute": "href" },
    	ig_url: {"type": "string", "source": "attribute", "default": "", "selector": "a.ig_a_link", "attribute": "href" },
    	in_url: {"type": "string", "source": "attribute", "default": "", "selector": "a.in_a_link", "attribute": "href" },
    },
    edit,
    save,
} );